'use client';

import { Scroll } from '@terra/ui-design-system';
import { Box, VStack } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';

export const DASHBOARD_ACTION_LIST_HEIGHT = 264;

type DashboardActionListProps = {
  children: ReactNode;
};

export function DashboardActionList({ children }: DashboardActionListProps) {
  return (
    <Box
      position="relative"
      flex={1}
      mx={-4}
      mb={-4}
      style={{ minHeight: DASHBOARD_ACTION_LIST_HEIGHT }}
    >
      <Box position="absolute" inset={0}>
        <Scroll orientation="vertical" showScrollbar h="full">
          <VStack gap={0} alignItems="stretch">
            {children}
          </VStack>
        </Scroll>
      </Box>
    </Box>
  );
}
